import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

import { ref, } from 'vue';
import { IonPage, IonContent } from '@ionic/vue'
import { BasicLoading, BasicSliderButton } from '@components/basic'
import MovePlacementsSelectedModal from '@components/move-placements/MovePlacementsSelectedModal.vue'
import MovePlacementsPutArticlesHeader from '@components/move-placements/MovePlacementsPutArticlesHeader.vue'
import MovePlacementsSelectedPlaceArticlesList from '@/components/move-placements/MovePlacementsSelectedPlaceArticlesList.vue'
import useSelectArticlesToPut from './_inner/useSelectArticlesToPut'
import useScanner from '@/composable/useScanner';


export default /*#__PURE__*/_defineComponent({
  __name: 'PutArticlesToMoveView',
  setup(__props) {

const isOpen = ref(false)

const {
  isLoading,
  canSubmit,
  handleScan,
  submitMovePlacementAction
} = useSelectArticlesToPut()

useScanner({ onScan(code) { handleScan(code) } })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(MovePlacementsPutArticlesHeader, {
        onShowSelected: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = true))
      }),
      _createVNode(_unref(IonContent), {
        fullscreen: true,
        class: "ion-padding"
      }, {
        default: _withCtx(() => [
          (_unref(isLoading))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(BasicLoading), { "is-loading": _unref(isLoading) }, null, 8, ["is-loading"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(MovePlacementsSelectedPlaceArticlesList, { mode: "put" }),
          _createVNode(MovePlacementsSelectedModal, {
            "is-open": isOpen.value,
            "onUpdate:isOpen": _cache[1] || (_cache[1] = ($event: any) => ((isOpen).value = $event)),
            "divide-by-place": false
          }, null, 8, ["is-open"]),
          _createVNode(_unref(BasicSliderButton), {
            onOnSuccess: _unref(submitMovePlacementAction),
            disabled: !_unref(canSubmit),
            size: 48
          }, null, 8, ["onOnSuccess", "disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})